import React from 'react';
import { useGetPage } from 'hooks/useGetPage';
import { pageIds } from 'utilities/constants';
import moment from 'moment/moment';
import { STANDARD_DATE } from 'utilities/dateHelper';
import { Card } from '../Card';

const SummaryComingSoon = ({ lastUpdated }: { lastUpdated?: string }) => {
  const { data: locale } = useGetPage({
    locale: 'en',
    pageId: pageIds.COMPLETE_MY_VISIT_SUMMARY_MODAL,
  });

  return (
    <Card
      title={locale?.summaryDetails}
      titleClassName="flex text-h4 text-btn-black font-semibold"
      showSeparator
      defaultExpanded
      subtitleClassName="!text-base font-medium max-desktop:mt-2.5"
      subtitle={moment(lastUpdated).format(`[Summary date:] ${STANDARD_DATE}`)}
    >
      <div className="w-full h-full text-center py-48 px-32">
        <div className="text-lg font-semibold mb-1">
          Appointment completed. Your visit summary coming soon
        </div>
        <div className="font-medium text-center text-med-gray-3">
          Thanks for attending your appointment. Your healthcare provider is
          finalizing the summary. You’ll be informed by notification once it’s
          available.
        </div>
      </div>
    </Card>
  );
};

export default SummaryComingSoon;
